var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.author||_vm.client)?_c('figure',{staticClass:"user_image image is-48x48",attrs:{"id":"clientFigure"}},[_c('img',{staticClass:"is-rounded",attrs:{"src":_vm.getPicture(),"id":"clientProfilePicture","alt":"Profilbild"}})]):_c('div',{staticClass:"user_image image is-48x48 skeleton"})
}
var staticRenderFns = []

export { render, staticRenderFns }